<script>
import moment from "moment";
import { Modal } from 'bootstrap';
import axios from '@/utils/axios';
import { allUsers } from '@/utils/user';
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import DateRangePicker from "daterangepicker";
import LeadStageChart from '@/components/analytic/lead-stage-chart.vue';
import QuotationChart from '@/components/analytic/quotation-chart.vue';

export default {
  inject: ['setLoading'],
  components: {
   LeadStageChart,
   QuotationChart
  },
  data() {
    return {
      errors: {},  
      chartKey: 0,
      chartKeyProposalStatus: 0,
      chartKeyQuotationStatus: 0,
      errors: {},
      title: "Reports",
      text: "User Summary Report",
      text1: "Reports",
      isCollapsed: false,
      filter: {
        user: '',
        from_date: '',
        to_date: '',
      },
      users: [],
      total_leads: 0,
      active_leads: 0,
      converted_leads: 0,
      total_proposals: 0,
      total_quotations: 0,
      stage_wise_lead_distribution: [],
      lead_stage_chart_config: {
        type: 'doughnut',
        data: {
          labels: [],
          datasets: [{
            label: 'Lead Stage',
            data: [],
            backgroundColor: [],
            borderWidth: 5,
            borderRadius: 10,
            borderColor: '#fff',
            hoverBorderWidth: 0,
            cutout: '60%',
          }]
        },
        options: {
          rotation: -100,
          circumference: 200,
          layout: { padding: { top: -20, bottom: -20 } },
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } }
        }
      },

      proposal_status_chart_config: {
        type: 'bar',
        stacked: true,
        data: {
          labels: [],
          datasets: [{
            label: 'Proposal Status',
            data: [],
            backgroundColor: [],
            borderWidth: 1,
            borderColor: '#fff',
            borderRadius: 4,
            hoverBorderWidth: 0,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1,
              },
            }
          }
        },
      },

      quotation_status_chart_config: {
        type: 'bar',
        stacked: true,
        data: {
          labels: [],
          datasets: [{
            label: 'Quotation Status',
            data: [],
            backgroundColor: [],
            borderWidth: 1,
            borderColor: '#fff',
            borderRadius: 4,
            hoverBorderWidth: 0,
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: {
                stepSize: 1,
              },
            }
          }
        },
      },

    };
  },

  computed: {
   leadChartData(){
    return {
     total_leads: this.total_leads,
     active_leads: this.active_leads,
     stage_wise_lead_distribution: this.stage_wise_lead_distribution 
    };
   },
   quotationReportData(){
    return {
     total_quotations: this.total_quotations,
     quotation_by_status: this.quotation_by_status 
    };
   }
  },

  mounted() {
    this.getUsers();
    
    const start = moment().subtract(6, "days");
    const end = moment();

    new DateRangePicker(
      this.$refs.dateRangeInput,
      {
        startDate: start,
        endDate: end,
        locale: {
         format: "DD/MM/YYYY",
         separator: " - "
        },
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        }
      },
      (start, end) => {
       this.setDateRange(start, end);
       if(this.filter.user){
        this.userReport();
       }
      },
      this.booking_range
    );
    // Initialize filter date range as soon as picker mounts
    this.setDateRange(start, end);
  },

  methods: {

    booking_range(start, end) {
     return start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
    },

    setDateRange(start, end) {
     this.filter.from_date = start.format("YYYY-MM-DD");
     this.filter.to_date = end.format("YYYY-MM-DD");
    },

    openStageLeads(stage){ 
     this.$refs.chartModal.getLeads(
     this.filter.user,    // user_id
     this.filter.from_date,      // from_date
     this.filter.to_date,        // to_date
     stage.stage_id,     // lead_stage_id from stage object
     this.branch_id,     // branch_id from parent
     1                   // page
    );

     // show Bootstrap modal
     const modalEl = document.getElementById('lead_detail_modal');
     if (modalEl) {
      const modal = Modal.getOrCreateInstance(modalEl);
      modal.show();
     }
    },

    async userReport() {
      this.errors = {};  
      this.setLoading(true);
      try{
        const payload = {
         user_id: this.filter.user,
         from_date: this.filter.from_date,
         to_date: this.filter.to_date
        };
        
        const response = await axios.get('/reports/user/summary', { params: payload });
        this.total_leads = response.data.data.total_leads;
        this.active_leads = response.data.data.active_leads;
        this.converted_leads = response.data.data.converted_leads;
        const distribution = response.data.data.stage_wise_lead_distribution || [];
        this.stage_wise_lead_distribution = distribution;

        this.lead_stage_chart_config = {
          type: 'doughnut',
          data: {
            labels: distribution.map(s => s.stage),
            datasets: [{
              label: "Lead Stages",
              data: distribution.map(s => Number(s.percentage) || 0),
              backgroundColor: distribution.map(s => s.color || '#999'),
              borderWidth: 5,
              borderRadius: 10,
              borderColor: '#fff',
              hoverBorderWidth: 0,
              cutout: '60%',
            }]
          },
          options: {
            rotation: -100,
            circumference: 200,
            layout: { padding: { top: -20, bottom: -20 } },
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { display: false } }
          }
        };
        this.chartKey++;

//#########################################################################

//#########################################################################

    const statusColors = {
     Draft: '#FFA726',
     Sent: '#29B6F6',
     Accepted: '#66BB6A',
     Rejected: '#EF5350'
    };
    this.total_proposals = response.data.data.total_proposals;
    const proposal_by_status = response.data.data.proposal_by_status;

     this.proposal_status_chart_config.data = {
        labels: ['Proposals'],
        datasets: proposal_by_status.map(item => ({
        label: item.status,
        data: [item.count],
        backgroundColor: statusColors[item.status] || '#999999',
        borderWidth: 1,
        borderColor: '#fff',
        borderRadius: 4,
        hoverBorderWidth: 0,
        }))
     };
     this.chartKeyProposalStatus++;

//#########################################################################

//#########################################################################

    this.total_quotations = response.data.data.total_quotations;
    const quotation_by_status = response.data.data.quotation_by_status;

     this.quotation_status_chart_config.data = {
        labels: ['Quotations'],
        datasets: quotation_by_status.map(item => ({
        label: item.status,
        data: [item.amount],
        backgroundColor: statusColors[item.status] || '#999999',
        borderWidth: 1,
        borderColor: '#fff',
        borderRadius: 4,
        hoverBorderWidth: 0,
        }))
     };
     this.chartKeyQuotationStatus++;     

      }catch(error){
       if(error.type == 'validation'){
        this.errors = error.errors;
       }else{
        this.$swalToast(error.message, 'error');
       }
      }finally{
       this.setLoading(false);
      }
    },

    async getUsers() {
     this.setLoading(true);
     try{
      const response = await allUsers();
      this.users = response.data.data;
     }catch(error){
      this.$swalToast(error.message, 'error');
     }finally{
      this.setLoading(false);
     }
    },

    clearFilter() {
     this.filter = {
      user: '',
     };
     this.total_leads = 0;
     this.total_quotations = 0;
      // Optionally reset date picker UI too
      // (e.g., manually set this.$refs.dateRangeInput.value)
    }
  }
};
</script>


<template>
 <layout-header></layout-header>
 <layout-sidebar></layout-sidebar>
<div class="page-wrapper">
<div class="content">
<!-- Breadcrumb -->
<div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
 <breadcrumb :title="title" :text="text" :text1="text1" />
<div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
<!-- <div class="me-2 mb-2">
<div class="dropdown">
<a href="javascript:void(0);" class="dropdown-toggle btn btn-white d-inline-flex align-items-center" data-bs-toggle="dropdown">
 <i class="ti ti-file-export me-1"></i>Export </a>
<ul class="dropdown-menu dropdown-menu-end p-3">
 <li>
  <a href="javascript:void(0);" class="dropdown-item rounded-1"><i class="ti ti-file-type-pdf me-1"></i>Export as PDF</a>
 </li>
 <li>
  <a href="javascript:void(0);" class="dropdown-item rounded-1"><i class="ti ti-file-type-xls me-1"></i>Export as Excel</a>
 </li>
</ul>
 </div>
</div> -->
<!-- <div class="mb-2">
<div class="input-icon w-120 position-relative">
 <span class="input-icon-addon"> 
  <i class="ti ti-calendar text-gray-9"></i>
 </span>
 <a-date-picker class="form-control yearpicker" picker="year" value="2025" placeholder="2025" />
</div>
</div> -->
<div class="ms-2 head-icons">
 
</div>
</div>
</div>
<!-- /Breadcrumb -->

<div class="card border-0">
<div class="card-body d-flex align-items-center justify-content-center flex-wrap pb-1">
  <div class="d-flex align-items-center flex-wrap mb-1">
   
   <div class="me-3" v-if="filter.user !== '' ">
     <a href="javascript:void(0);" class="text-danger" @click="clearFilter()"><i class="ti ti-filter-x"></i></a>
    </div>  

    <div class="me-3">
     <div class="input-icon-end position-relative">
      <input type="text" class="form-control date-range bookingrange" ref="dateRangeInput" placeholder="dd/mm/yyyy - dd/mm/yyyy">
      <span class="input-icon-addon"><i class="ti ti-chevron-down"></i></span>
     </div>
    </div>

    <div class="me-3 custom-vueselect">
     <vue-select :options="users" label="name" v-model="filter.user" placeholder="Select User" :reduce="u => u.id" @update:modelValue="userReport" /> 
     <div class="text-danger small mt-1" v-if="errors.user_id">{{ errors.user_id[0] }}</div>
    </div>

    <div class="me-3">
     <button type="button" class="btn btn-dark" @click="userReport"><i class="ti ti-search"></i></button>
    </div>
   
  </div>
</div>
</div>


  <div class="row">

  <div class="col-xxl-4 col-xl-7 d-flex">
   <LeadStageChart :chart-data="leadChartData" :chart-config="lead_stage_chart_config" :chart-key="chartKey" title="All Leads Distribution" center-label="Total Leads" @open-stage-leads="openStageLeads" />
  </div>

  <div class="col-xl-5 d-flex">
   <QuotationChart :chart-data="quotationReportData" :chart-config="quotation_status_chart_config" :chart-key="chartKeyQuotationStatus" title="Quotation Status Overview" />
  </div>

  </div>

  <div class="row" v-if="!this.total_leads && !this.total_quotations">
   <div class="p-3 text-center text-muted">
      No records found.
    </div>
  </div>

</div>

<app-footer></app-footer>

</div>

<chart-modal ref="chartModal"></chart-modal>

</template>